import { API_BASE_URL } from "../../../config";
import { apiFetch } from "../../../utils/api";

export const fetchProducts = async (authToken) => {
  const data = await apiFetch(`${API_BASE_URL}/api/offers/`, { token: authToken });
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data)) return data;
  return [];
};

export const updateProductRequest = async ({ authFetch, productId, updates }) => {
  const response = await authFetch(`${API_BASE_URL}/api/offers/${productId}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updates),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = payload?.detail || payload?.message || `HTTP ${response.status}`;
    throw new Error(detail);
  }
  return payload;
};
